module.exports = __webpack_public_path__ + "img/642.45ffd667.jpg";